import React from 'react';
import Styles from './tag-default-styles.scss';
const TagDefault = ({ text }) => {
    return (React.createElement("div", { className: Styles.containerDefault },
        React.createElement("span", { className: Styles.textDefault }, text)));
};
export default TagDefault;
